module.exports = __webpack_public_path__ + "img/914.932cd2aa.gif";